var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends-view"},[(_vm.webId != null)?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('viewfriends')))]),_c('FriendAdd'),_c('Friends')],1):_c('div',[_c('SolidLoginButton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }